import React from 'react';
import PropTypes from 'prop-types';
import AdvTopLevelWorkflow from '../AdvWorkflow/AdvTopLevelWorkflowContainer';
import AccountStep from './Steps/AccountsManualStepContainer';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../js/app/react/validators';

const FinancialAccountsWorkflowView = ({ clientId, isMobile, outputFunction, ...rest }) => (
  <AdvTopLevelWorkflow
    {...rest}
    hasAutoOutput
    clientId={clientId}
    analyticsWorkflowStarted="financial_accounts_workflow_started"
    outputFunction={outputFunction(clientId, isMobile)}
    steps={[AccountStep]}
  />
);

FinancialAccountsWorkflowView.propTypes = {
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  outputFunction: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default FinancialAccountsWorkflowView;
